<script>
import { authComputed } from "@/state/helpers";
import moment from "moment";
import errorHandler from "@/helpers/errorHandler";
import BookingService from "@/helpers/APIService/booking.service";

export default {
  components: {},
  props: {
    currentProps: Object,
  },
  data() {
    return {
      emailLogs: [],
      selectedEmailLog: [],
    };
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.getEmailLogs();
  },
  methods: {
    async getEmailLogs() {
      await BookingService.getEmailLogListOfBooking(
        this.currentProps.booking.id
      )
        .then((emailLogs) => {
          this.emailLogs = emailLogs;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    formatDate(date) {
      return moment(date).format("MMM, DD YYYY, hh:mm A");
    },
    openEmailLogActivity(log) {
      this.selectedEmailLog = log;
      this.$bvModal.show("viewActivity-modal");
    },
    resetModal() {
      this.selectedEmailLog = [];
    },
  },
};
</script>

<template>
  <b-tab>
    <template v-slot:title>
      <span class="d-inline-block d-sm-none">
        <i class="fas fa-home"></i>
      </span>
      <span class="d-none d-sm-inline-block">Email Log</span>
    </template>
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <h4 class="header-title mb-0 text-primary">Email Log</h4>
        </div>
        <div class="row">
          <div class="col-md-12 mt-3">
            <div class="table-responsive">
              <table class="table table-borderless">
                <thead class="thead-light bg-light">
                  <tr>
                    <th>Event Date</th>
                    <th>Subject</th>
                    <th>Send To</th>
                    <th>Status</th>
                    <th>Attempted</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(log, index) in emailLogs" :key="index">
                    <td>{{ formatDate(log.created_at) }}</td>
                    <td>{{ log.subject }}</td>
                    <td>{{ log.send_to }}</td>
                    <td>{{ log.mail_status }}</td>
                    <td>{{ log.attempted }}</td>
                    <td>
                      <div slot="view" class="d-flex align-items-center">
                        <i
                          class="fas fa-solid fa-eye"
                          id="view"
                          @click="openEmailLogActivity(log)"
                        ></i>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="viewActivity-modal"
      centered
      size="xl"
      hide-footer
      title="Email Log Details"
      title-class="font-18"
      @hidden="resetModal"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="table-responsive">
            <table class="table">
              <thead class="thead-light bg-light">
                <tr>
                  <th>Event</th>
                  <th>Client Device</th>
                  <th>Client OS</th>
                  <th>Geoip Continent</th>
                  <th>Geoip Country</th>
                  <th>Geoip City</th>
                  <th>srcHost</th>
                  <th>URL</th>
                  <th>Created At</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(log, index) in selectedEmailLog.email_log_activity"
                  :key="index"
                >
                  <td v-if="log.event != null">
                    <template>
                      <span
                        class="badge align-items-center py-1 px-2 card-badge"
                        :class="
                          log.event === 'delivered'
                            ? 'badge-soft-info'
                            : log.event === 'processed'
                            ? 'badge-soft-secondary'
                            : log.event === 'open'
                            ? 'badge-soft-success'
                            : log.event === 'spam'
                            ? 'badge-soft-danger'
                            : log.event === 'click'
                            ? 'badge-soft-primary'
                            : log.event === 'unsubscribe'
                            ? 'badge-soft-dark'
                            : 'badge-soft-light'
                        "
                      >
                        {{ log.event }}
                      </span>
                    </template>
                  </td>
                  <td v-else>
                    {{ "-" }}
                  </td>
                  <td>
                    {{ log.client_device != null ? log.client_device : "-" }}
                  </td>
                  <td>{{ log.client_os != null ? log.client_os : "-" }}</td>
                  <td>
                    {{
                      log.geoip_continent != null ? log.geoip_continent : "-"
                    }}
                  </td>
                  <td>
                    {{ log.geoip_country != null ? log.geoip_country : "-" }}
                  </td>
                  <td>{{ log.geoip_city != null ? log.geoip_city : "-" }}</td>
                  <td>{{ log.srchost != null ? log.srchost : "-" }}</td>
                  <td>
                    <a
                      v-if="log.url != null"
                      :href="[log.url != null ? log.url : 'javascript:void(0)']"
                      ><i
                        class="mdi mdi-web fs-4 text-primary"
                        v-b-popover.hover.top="log.url"
                      ></i
                    ></a>
                    <div v-else>-</div>
                  </td>
                  <td>{{ formatDate(log.created_at) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </b-modal>
  </b-tab>
</template>
